import { Stack } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useModalContext } from 'store/modal';
import { ContentLanguage } from 'types/general';
import { Button, Tabs } from 'melp-design/components';
import { formatLanguage } from 'utils/format';
import { Add } from '@mui/icons-material';
import { LanguagesSelectModal } from 'components/modals';

interface LanguagesInputProps {
  availableLanguages: Uppercase<ContentLanguage>[];
  disabledLanguages: Uppercase<ContentLanguage>[];
  selectedLanguages: Uppercase<ContentLanguage>[];
  selectedLanguage: Uppercase<ContentLanguage>;
  onLanguagesChange: (value: Uppercase<ContentLanguage>[]) => void;
  onSelectedChange: (value: Uppercase<ContentLanguage>) => void;
  disabled?: boolean;
}

export const LanguagesInput: FC<LanguagesInputProps> = ({
  availableLanguages,
  disabledLanguages,
  selectedLanguages,
  selectedLanguage,
  onLanguagesChange,
  onSelectedChange,
  disabled,
}) => {
  const { i18n } = useTranslation();
  const { openModal } = useModalContext();

  return (
    <Stack direction="row" gap={1} alignItems="center">
      <Tabs
        value={selectedLanguage}
        items={selectedLanguages.map((language) => ({
          label: formatLanguage(i18n.language, language),
          value: language,
        }))}
        onChange={(selected) => onSelectedChange(selected)}
      />

      <Button
        icon={Add}
        variant="tertiary"
        size="sm"
        disabled={disabled}
        onClick={async () => {
          const result = await openModal({
            component: LanguagesSelectModal,
            props: {
              initialLanguages: selectedLanguages,
              languages: availableLanguages,
              disabledLanguages,
              type: 'checkbox',
            },
          });

          if (result.action === 'CONFIRM') {
            onLanguagesChange(result.languages);
          }
        }}
      />
    </Stack>
  );
};
